import { useState } from "react";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactUpcomingSlot from "./CompactUpcomingSlot";
import ExtendedUpcomingSlot from "./ExtendedUpcomingSlot";
import { CancelSessionRequest } from "../../modal/views/CancelSessionRequest";
import WeeklySessionInfo from "../../sessions/WeeklySessionInfo";

export default function UpcomingSlot(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
  cancel?: boolean;
}) {
  const [open, setOpen] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (props.compact) {
    return (
      <>
        <CompactUpcomingSlot setOpen={() => setOpen(true)} {...props} />
        {!!props?.slot && !!props?.cancel && (
          <>
            <WeeklySessionInfo
              session={props?.slot}
              onClose={() => setOpen(false)}
              cancel={!!props?.cancel}
              open={open}
              setIsOpen={() => {
                setOpen(false);
                setIsOpen(true);
              }}
            />
            <CancelSessionRequest
              isOpen={isOpen}
              session={props?.slot}
              setIsOpen={() => setIsOpen(false)}
            />
          </>
        )}
      </>
    );
  }
  return <ExtendedUpcomingSlot {...props} />;
}
